var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { ElementRef, NgZone } from '@angular/core';
import { ReferenceDataService } from '../../services/reference-data/reference-data.service';
import { UserService } from '../../services/user.service';
import { DiscoverFilterBar, FilterSearch } from '../../../models/filter-search';
import { InfluencerGroup } from '../../../models/influencer-group';
import { ModalService } from '../../services/modal/modal.service';
import { DiscoverService } from '../../services/discover/discover.service';
import { CampaignInfluencerStatus, CommonConstant, discoverFilterSearchConst } from '../../app.constants';
import { AchooPopupComponent } from '../../core/achoo-popup/achoo-popup.component';
import { ActivatedRoute, Router } from '@angular/router';
import { Location as NgCommonLocation } from '@angular/common';
import { PlaceholderVisibilityService } from '../../services/placeholder-visibility/placeholder-visibility.service';
import { CacheService } from '../../services/cache/cache.service';
import { AchooTabsComponent } from '../../core/achoo-tabs/achoo-tabs.component';
import { DiscoverSearchComponent } from './discover-search/discover-search.component';
import { AbstractAchooComponent } from '../abstract-achoo.component';
import { ObjectUtils } from '../../utils/object.utils';
import { ActionSource, ActivePages, EventTrackerService, Page, TargetType, UserActionType } from '../../services/event-tracker/event-tracker.service';
import { DateUtils } from '../../utils/date.utils';
import { TranslateService } from '@ngx-translate/core';
import { PostListComponent } from '../influencer/post-list/post-list.component';
import { CampaignService } from '../../services/campaign/campaign.service';
import { InfluencerGroupsService } from '../influencer-groups/influencer-groups.service';
import { environment } from '../../../environments/environment';
var DiscoverTab;
(function (DiscoverTab) {
    DiscoverTab["POST"] = "posts";
    DiscoverTab["INFLUENCER"] = "influencers";
})(DiscoverTab || (DiscoverTab = {}));
var DiscoverComponent = /** @class */ (function (_super) {
    __extends(DiscoverComponent, _super);
    function DiscoverComponent(referenceDataService, userService, discoverService, modalService, router, location, placeholderService, campaignService, influencerGroupService, cacheService, activatedRoute, eventTracker, translate, ngZone) {
        var _this = _super.call(this, userService) || this;
        _this.referenceDataService = referenceDataService;
        _this.userService = userService;
        _this.discoverService = discoverService;
        _this.modalService = modalService;
        _this.router = router;
        _this.location = location;
        _this.placeholderService = placeholderService;
        _this.campaignService = campaignService;
        _this.influencerGroupService = influencerGroupService;
        _this.cacheService = cacheService;
        _this.activatedRoute = activatedRoute;
        _this.eventTracker = eventTracker;
        _this.translate = translate;
        _this.ngZone = ngZone;
        _this.influencerGroup = new InfluencerGroup();
        _this.scrollDistance = CommonConstant.DEFAULT_INFINITE_SCROLL_DISTANCE;
        _this.scrollUpDistance = CommonConstant.DEFAULT_INFINITE_SCROLL_DISTANCE_UP;
        _this.throttle = CommonConstant.DEFAULT_INFINITE_SCROLL_THROTTLE_100;
        _this.currentFilterSearch = new FilterSearch();
        _this.currentPageIndex = CommonConstant.START_PAGE_INDEX;
        _this.isShowBottomBar = false;
        /** these flag are using for pre-loader
         * isFetchingNextInfluencers -> using when fetching the next result. Do not perform a next pre-loader when next result is fetching
         * isWaitingNextInfluencers -> when user want to see the next result, but the fetching of next result is not completed. This flag will be enabed.
         **/
        _this.isFetchingNextInfluencers = false;
        _this.isWaitingNextInfluencers = false;
        _this.isFetchingNextPosts = false;
        _this.isWaitingNextPosts = false;
        // caching pre-loaded data of next result
        _this.storedDiscoverInfluencers = [];
        _this.storedDiscoverPosts = [];
        // current influencer result list
        _this.discoverInfluencers = [];
        // selected preview influencer list
        _this.selectedPreviewInfluencers = [];
        // current post result list
        _this.discoverPosts = [];
        // selected preview post list
        _this.selectedPreviewPosts = [];
        // list campaign to add to post
        _this.campaignListToPost = [];
        _this.showWarningSearchMessage = true;
        _this.searchRunning = false;
        _this.missingRequiredFilters = true;
        _this.isRenderedPostList = false;
        _this.env = environment;
        _this.isLoadingCampaignList = false;
        _this.isLoadingGroupList = false;
        _this.isLoadingProjectList = false;
        // This is default groupId to display overview of influencer
        _this.influencerGroupId = 0;
        _this.discoverFilterBar = new DiscoverFilterBar();
        _this.discoverFilterBar.countries = _this.referenceDataService.countries;
        _this.discoverFilterBar.platforms = _this.referenceDataService.platforms.filter(function (platform) { return _this.env.activePlatforms.find(function (activePlatform) { return platform.name.toLowerCase() === activePlatform; }); });
        _this.discoverFilterBar.topics = _this.referenceDataService.activeTopics;
        _this.discoverFilterBar.industries = _this.referenceDataService.verticals;
        _this.discoverFilterBar.genders = CommonConstant.GENDERS;
        _this.currentFilterSearch.orderBy = 'latest';
        // get discover posts and filters search from cached
        if (_this.cacheService.has(CommonConstant.DISCOVER_TAB)) {
            _this.cacheService.get(CommonConstant.DISCOVER_TAB).subscribe(function (data) {
                _this.tabKey = data;
                _this.showWarningSearchMessage = false;
                _this.missingRequiredFilters = false;
                _this.replaceTabState(_this.tabKey);
            });
        }
        else {
            var currentTab = _this.activatedRoute.snapshot.data.activeTab;
            _this.replaceTabState(currentTab);
        }
        _this.discoverService.moveOutDiscoverSubject.subscribe(function (res) {
            // don't anything if discover page doesn't active
            if (!_this.discoverService.isActiveDiscoverPage) {
                return;
            }
            if (res && _this.activeBottomBar === 'inactive') {
                _this.activeBottomBar = null;
            }
            if (!res) {
                if (!_this.isLoadingGroupList) {
                    _this.loadGroupList(_this.userService.getCompanyId());
                }
                if (!_this.isLoadingCampaignList) {
                    _this.loadCampaignList(_this.userService.getCompanyId());
                }
                if (!_this.isLoadingProjectList) {
                    _this.loadListProject(_this.userService.getCompanyId());
                }
            }
        });
        return _this;
    }
    DiscoverComponent.prototype.ngOnInit = function () {
        _super.prototype.ngOnInit.call(this);
        this.discoverService.activeDiscoverPage();
        this.loadListProject(this.companyId, this.triggerSearchByProjectList.bind(this));
    };
    DiscoverComponent.prototype.ngOnDestroy = function () {
        _super.prototype.ngOnDestroy.call(this);
        // unsubscribe all subscriptions before destroying component
        this.cancelPendingSearchRequest();
    };
    DiscoverComponent.prototype.onWindowScroll = function () {
        var _this = this;
        this.ngZone.runOutsideAngular(function () {
            if (_this.discoverService.isAllowToCacheScrollPosition) {
                _this.cacheService.set(CommonConstant.DISCOVER_SCROLL_TOP, document.documentElement.scrollTop);
            }
        });
    };
    DiscoverComponent.prototype.loadListProject = function (companyId, callback) {
        var _this = this;
        this.isLoadingProjectList = true;
        this.cacheService.get("all_projects_of_advertiser_" + companyId, this.userService.getAllProjectOfAdvertiser()).subscribe(function (res) {
            _this.isLoadingProjectList = false;
            if (!res || !res.data) {
                return;
            }
            var listProject = res.data.map(function (project) { return ({
                id: project.id,
                name: project.name,
                countries: project.projectCountries.map(function (item) { return item.country.id; }),
                keywords: project.projectKeywords.map(function (item) { return item.keyword; })
            }); });
            _this.discoverFilterBar.projects = listProject;
            if (callback) {
                callback();
            }
        }, function (err) {
            _this.isLoadingProjectList = false;
        });
    };
    DiscoverComponent.prototype.afterAddNewProjectFromBottombar = function (evt) {
        var cloneFilters = ObjectUtils.deepClone(this.discoverFilterBar);
        cloneFilters.projects.push(evt);
        this.discoverFilterBar = cloneFilters;
    };
    DiscoverComponent.prototype.triggerSearchByProjectList = function () {
        var listProject = this.discoverFilterBar.projects;
        // stop immediately if no project availabel
        if (!Array.isArray(listProject) || listProject.length === 0) {
            return;
        }
        // set the first project as default search criteria for freemium user
        if (this.userService.isFreeUser()) {
            // set the first project as the default selection project
            var firstNoneEmptyProject = this.findFirstNoneEmptyProject(listProject);
            if (!firstNoneEmptyProject) {
                return null;
            }
            var keywords = firstNoneEmptyProject.keywords.map(function (item) { return item.keyword; });
            var countries = firstNoneEmptyProject.countries;
            this.discoverySearchBar.countriesOfProject = countries;
            this.discoverySearchBar.keywordsOfProject = keywords;
            this.currentFilterSearch.projects = [firstNoneEmptyProject.id];
            this.currentFilterSearch.mentions = keywords;
            this.currentFilterSearch.countries = countries;
            // keep track the discovery search criteria to compare
            if (this.discoverySearchBar) {
                this.discoverySearchBar.previousFilterCriteria = ObjectUtils.deepClone(this.currentFilterSearch);
            }
            // start discover search by project
            this.onSearchDiscoverData(this.currentFilterSearch);
        }
    };
    DiscoverComponent.prototype.canStartLoadingDiscoverDataFromServer = function (tabKey) {
        if (tabKey === DiscoverTab.INFLUENCER) {
            return !this.cacheService.has(CommonConstant.HAVE_TRIGGERED_DISCOVER_INFLUENCER);
        }
        else {
            return !this.cacheService.has(CommonConstant.HAVE_TRIGGERED_DISCOVER_POST);
        }
    };
    // handle Change Account from User Menu (companyId)
    DiscoverComponent.prototype.companyChangeCallback = function (companyId) {
        var _this = this;
        // reset current data and cancel request
        this.cancelPendingSearchRequest();
        // update Tab state
        this.updateTabState();
        this.missingRequiredFilters = true;
        this.discoverInfluencers = [];
        this.storedDiscoverInfluencers = [];
        this.discoverPosts = [];
        this.storedDiscoverPosts = [];
        this.selectedPreviewPosts = [];
        this.selectedPreviewInfluencers = [];
        this.totalDiscoverPost = 0;
        this.totalDiscoverInfluencer = 0;
        this.lastSortValues = [];
        // reset current filter search
        this.currentFilterSearch.projects = [];
        this.currentFilterSearch.influencers = [];
        this.currentFilterSearch.mentions = [];
        // reset project list
        this.discoverFilterBar.projects = [];
        // load campaign list
        this.currentActiveAccount = companyId;
        this.loadCampaignList(companyId);
        // load list influencer group
        this.loadGroupList(companyId);
        this.discoverService.getInfluencerGroupListSideBarMenu(companyId).subscribe(function (res) {
            _this.discoverFilterBar.influencers = res;
        });
        // load list of project of current user
        this.loadListProject(this.companyId, this.triggerSearchByProjectList.bind(this));
    };
    DiscoverComponent.prototype.loadCampaignList = function (companyId) {
        var _this = this;
        if (!companyId) {
            return;
        }
        this.isLoadingCampaignList = true;
        this.campaignService.getCampaignShortListForCompany(companyId).subscribe(function (res) {
            _this.campaignList = res.filter(function (campaignItem) { return campaignItem.status !== CampaignInfluencerStatus.ARCHIVED; }).map(function (campaign) { return ({
                id: campaign.id,
                name: campaign.name,
                brief: campaign.brief
            }); });
            _this.campaignListToPost = _this.campaignList;
            _this.isLoadingCampaignList = false;
        }, function (err) {
            _this.isLoadingCampaignList = false;
        });
    };
    DiscoverComponent.prototype.loadGroupList = function (companyId) {
        var _this = this;
        if (!companyId) {
            return;
        }
        this.isLoadingGroupList = true;
        this.influencerGroupService.getInfluencerGroupShortList(companyId).subscribe(function (res) {
            _this.influencerGroupList = res.map(function (group) { return ({
                id: group.id,
                name: group.name,
                description: group.description
            }); });
            _this.isLoadingGroupList = false;
        }, function (err) {
            _this.isLoadingGroupList = false;
        });
    };
    DiscoverComponent.prototype.findFirstNoneEmptyProject = function (listProject) {
        return listProject.find(function (p) { return Array.isArray(p.keywords) && p.keywords.length > 0; });
    };
    DiscoverComponent.prototype.beforeActiveBottomBar = function (bottomBarHeight) {
        this.activeBottomBar = 'active';
    };
    DiscoverComponent.prototype.closeBottonBar = function (evt) {
        if (evt.isReloadInfluencerList) {
            this.reloadDiscoverInfluencerList();
        }
        this.activeBottomBar = 'inactive';
    };
    DiscoverComponent.prototype.clearSelection = function (activeTab) {
        if (activeTab === DiscoverTab.INFLUENCER) {
            this.selectedPreviewInfluencers = [];
        }
        else {
            this.selectedPreviewPosts = [];
        }
    };
    DiscoverComponent.prototype.showClearFilterWarningPopup = function () {
        this.modalService.openInCenter(this.clearFilterWarningPopup);
    };
    DiscoverComponent.prototype.clearSearchResultAndFilter = function () {
        // clear search result
        this.cancelPendingSearchRequest();
        this.discoverInfluencers = [];
        this.discoverPosts = [];
        this.totalDiscoverInfluencer = 0;
        this.totalDiscoverPost = 0;
        this.lastSortValues = [];
        // clear cache
        this.cacheService.clear(CommonConstant.HAVE_TRIGGERED_DISCOVER_POST);
        this.cacheService.clear(CommonConstant.HAVE_TRIGGERED_DISCOVER_INFLUENCER);
        // reset filter
        this.currentFilterSearch = new FilterSearch();
        this.missingRequiredFilters = true;
        this.updateTabState();
        this.hideAlertPopupMessage();
        // update activity filter UI
        this.discoverySearchBar.hasFilterActivity = false;
        this.discoverySearchBar.resetActivityFilters();
        this.discoverySearchBar.resetAudienceFilters(true);
        this.discoverySearchBar.resetInterestFilters(true);
    };
    DiscoverComponent.prototype.onInvalidSearchCriteria = function () {
        this.missingRequiredFilters = true;
        this.discoverInfluencers = [];
        this.storedDiscoverInfluencers = [];
        this.discoverPosts = [];
        this.totalDiscoverPost = 0;
        this.totalDiscoverInfluencer = 0;
        this.storedDiscoverPosts = [];
        this.lastSortValues = [];
        this.updateTabState();
    };
    /**
     * trigger search when changing search criteria
     * @param {FilterSearch} searchCriteria
     */
    DiscoverComponent.prototype.onChangeSearchCriteria = function (searchCriteria) {
        // clear cache data
        this.cacheService.clear(CommonConstant.HAVE_TRIGGERED_DISCOVER_INFLUENCER);
        this.cacheService.clear(CommonConstant.HAVE_TRIGGERED_DISCOVER_POST);
        this.onSearchDiscoverData(searchCriteria);
    };
    /**
     * Search discover data on filter change
     * @param filterSearch
     */
    DiscoverComponent.prototype.onSearchDiscoverData = function (filterSearch) {
        this.isRenderedPostList = false;
        // reset offset
        filterSearch.offset = 0;
        filterSearch.limit = 0;
        filterSearch.period = discoverFilterSearchConst.period;
        // compute offset and limit
        this.computeNextResultLimitAndOffset(filterSearch);
        // remove warning message
        this.missingRequiredFilters = false;
        // update search criteria
        this.currentFilterSearch = filterSearch;
        // cancel the pending search request before executing the new one
        this.cancelPendingSearchRequest();
        // perform a search request
        if (this.tabKey === DiscoverTab.INFLUENCER) {
            // clear up the previous data
            this.discoverInfluencers = [];
            this.storedDiscoverInfluencers = [];
            // perform search request
            this.searchDiscoverInfluencer(filterSearch, false);
        }
        else {
            // clear up the previous data
            this.discoverPosts = [];
            // perform search request
            this.searchDiscoverPost(filterSearch, false);
        }
        // segment track search discover action
        this.eventTracker.trackUserAction(UserActionType.ACTION, Page.DISCOVER, {
            type: Page.DISCOVER
        }, __assign({ action: UserActionType.SEARCH, source: ActionSource.PAGE }, filterSearch), undefined, {
            type: ActivePages.DISCOVER
        });
    };
    DiscoverComponent.prototype.onScrollDown = function () {
        // prevent infinite load when active route is not Discover
        if (!this.discoverService.isActiveDiscoverPage) {
            return;
        }
        if (this.currentFilterSearch && !this.discoverService.isScrollingToPreviousPosition) {
            if (this.tabKey === DiscoverTab.INFLUENCER) {
                this.currentPageIndex++;
                this.fetchDiscoverInfluencersFromCaching(this.currentFilterSearch);
            }
            else if (this.tabKey === DiscoverTab.POST) {
                this.isRenderedPostList = false;
                this.currentPageIndex++;
                this.fetchDiscoverPostsFromCaching(this.currentFilterSearch);
            }
        }
    };
    DiscoverComponent.prototype.afterRenderPostList = function () {
        this.isRenderedPostList = true;
    };
    DiscoverComponent.prototype.onSelectedInfluencer = function (influencer) {
        if (influencer.selected) {
            var existedItems = this.selectedPreviewInfluencers.filter(function (item) { return item.influencer_id === influencer.influencer_id; });
            if (existedItems.length === 0) {
                influencer.previewed = true;
                this.selectedPreviewInfluencers.push(influencer);
                // track event to Segment
                this.eventTracker.trackUserAction(UserActionType.ACTION, Page.DISCOVER, {
                    id: influencer.influencer_id,
                    name: influencer.influencer_name,
                    type: TargetType.INFLUENCER
                }, {
                    action: UserActionType.SELECTION,
                    source: ActionSource.PAGE,
                }, undefined, {
                    type: ActivePages.DISCOVER,
                });
            }
        }
        else {
            // remove unselected item
            this.selectedPreviewInfluencers = this.selectedPreviewInfluencers.filter(function (item) { return item.influencer_id !== influencer.influencer_id; });
        }
        if (this.isShowBottomBar) {
        }
    };
    DiscoverComponent.prototype.onPreviewBottomBarOpen = function (isOpen) {
        this.isShowBottomBar = isOpen;
    };
    DiscoverComponent.prototype.onSelectedPost = function (post) {
        var existedItems = this.selectedPreviewPosts.filter(function (item) { return item.url_hash === post.url_hash; });
        if (existedItems.length === 0) {
            post.selected = true;
            post.previewed = true;
            this.selectedPreviewPosts.push(post);
            // track event to Segment
            this.eventTracker.trackUserAction(UserActionType.ACTION, Page.DISCOVER, {
                id: post.url_hash,
                name: post.title,
                type: TargetType.POST
            }, {
                action: UserActionType.SELECTION,
                source: ActionSource.PAGE,
            }, undefined, {
                type: ActivePages.DISCOVER,
            });
        }
    };
    DiscoverComponent.prototype.reloadDiscoverInfluencerList = function () {
        this.onSearchDiscoverData(this.currentFilterSearch);
    };
    /**
     * @param filterSearch
     * preload the next result for the next request
     * because the performance of dicover is too slow
     * we need to perform an ahead request to preload the data. Then when user scroll down to the end of page
     * They don't need to wait for fetching next result.
     */
    DiscoverComponent.prototype.preloadDataForDiscoverInfluencer = function (filterSearch) {
        this.computeNextResultLimitAndOffset(filterSearch);
        this.searchDiscoverInfluencer(filterSearch, true);
    };
    DiscoverComponent.prototype.fetchDiscoverInfluencersFromCaching = function (filterSearch) {
        this.discoverInfluencers = this.discoverInfluencers.concat(this.storedDiscoverInfluencers);
        // clear store
        this.storedDiscoverInfluencers = [];
        // update current offset
        this.currentOffset = filterSearch.offset + filterSearch.limit;
        this.filterPreviewedItemAsSelected(DiscoverTab.INFLUENCER);
        // if the current result is loaded, start loading the next result
        if (!this.isFetchingNextInfluencers) {
            this.preloadDataForDiscoverInfluencer(filterSearch);
        }
        else {
            // if the next result is loading, waiting for the next result
            this.isWaitingNextInfluencers = true;
            this.placeholderService.show(CommonConstant.DISCOVER_INFLUENCER_LIST_HOLDER);
        }
    };
    /**
     * @param filterSearch
     * preload the next result for the next request
     * because the performance of dicover is too slow
     * we need to perform an ahead request to preload the data. Then when user scroll down to the end of page
     * They don't need to wait for fetching next result.
     */
    DiscoverComponent.prototype.preloadDataForDiscoverPost = function (filterSearch) {
        this.computeNextResultLimitAndOffset(filterSearch);
        this.searchDiscoverPost(filterSearch, true);
    };
    DiscoverComponent.prototype.fetchDiscoverPostsFromCaching = function (filterSearch) {
        if (this.storedDiscoverPosts.length === 0 && !this.isFetchingNextPosts) {
            this.isRenderedPostList = true;
        }
        this.discoverPosts = this.discoverPosts.concat(this.storedDiscoverPosts);
        this.storedDiscoverPosts = [];
        // update current offset
        this.currentOffset = filterSearch.offset + filterSearch.limit;
        this.filterPreviewedItemAsSelected(DiscoverTab.POST);
        if (!this.isFetchingNextPosts) {
            this.preloadDataForDiscoverPost(filterSearch);
        }
        else {
            // if the next result is loading, waiting for the next result
            this.isWaitingNextPosts = true;
            this.placeholderService.show(CommonConstant.DISCOVER_POST_LIST_HOLDER);
        }
    };
    DiscoverComponent.prototype.hideAlertPopupMessage = function () {
        this.modalService.close();
    };
    DiscoverComponent.prototype.replaceTabState = function (tabKey) {
        if (!tabKey) {
            this.tabKey = DiscoverTab.INFLUENCER;
        }
        else {
            this.tabKey = tabKey;
        }
        var queryParams;
        if (this.userService.getCompanyId()) {
            queryParams = Object.assign({}, this.activatedRoute.snapshot.queryParams, { activeAccount: this.userService.getCompanyId() });
        }
        else {
            queryParams = Object.assign({}, this.activatedRoute.snapshot.queryParams);
        }
        var url = this.router.createUrlTree(['/discover', this.tabKey], {
            queryParams: queryParams
        });
        this.location.replaceState(url.toString());
        if (this.canStartLoadingDiscoverDataFromServer(this.tabKey)) {
            this.onSearchDiscoverData(this.currentFilterSearch);
            this.storedFilterSearch = Object.assign({}, this.currentFilterSearch);
        }
    };
    DiscoverComponent.prototype.updateTabState = function () {
        if (this.discoverTabs) {
            this.discoverTabs.delayUpdate();
        }
    };
    DiscoverComponent.prototype.orderDiscoverList = function (orderField) {
        if (this.currentFilterSearch && !this.missingRequiredFilters && !this.compareCurrentFilterWithPreviousFilter()) {
            this.currentFilterSearch.orderBy = orderField;
            this.onChangeSearchCriteria(this.currentFilterSearch);
        }
    };
    DiscoverComponent.prototype.openIncompletedStoryWarning = function (post) {
        var hourDiff = DateUtils.computeTimeDiffInHour(new Date(post.date), new Date());
        if (hourDiff > 24) {
            this._storyIcompleteMessage = this.translate.instant('story.error.incompleted_over_24h');
        }
        else {
            this._storyIcompleteMessage = this.translate.instant('story.error.incompleted');
        }
        this.modalService.open(this.warningOpenIncompletedStory, null, false);
    };
    DiscoverComponent.prototype.compareCurrentFilterWithPreviousFilter = function () {
        return JSON.stringify(this.currentFilterSearch) === JSON.stringify(this.storedFilterSearch);
    };
    DiscoverComponent.prototype.searchDiscoverPost = function (filterSearch, preloadData) {
        var _this = this;
        // should not show placeholder when preloading data
        if (preloadData) {
            this.isFetchingNextPosts = true;
            this.preloadDiscoverInfluencerSubcription = this.discoverService.searchPosts(filterSearch)
                .subscribe(function (res) {
                _this.isFetchingNextPosts = false;
                // update the total result post and pagination data
                _this.totalDiscoverPost = res.totalPosts;
                _this.updateSearchAfter(res.lastSortValues);
                if (_this.isWaitingNextPosts) {
                    // update search result for current discover list, filter duplicates
                    // TODO: Remove this hacky solution
                    var nextResult = res.posts.filter(function (i) { return !_this.discoverPosts.find(function (d) { return d.urlHash === i.urlHash; }); });
                    _this.discoverPosts = _this.discoverPosts.concat(nextResult);
                    _this.isWaitingNextPosts = false;
                    _this.placeholderService.hide(CommonConstant.DISCOVER_POST_LIST_HOLDER);
                    _this.preloadDataForDiscoverPost(filterSearch);
                }
                else {
                    _this.storedDiscoverPosts = res.posts;
                }
            }, function (err) {
                _this.placeholderService.hide(CommonConstant.DISCOVER_POST_LIST_HOLDER);
            });
        }
        else {
            this.showWarningSearchMessage = false;
            this.searchRunning = true;
            this.updateSearchAfter([]);
            // show placeholder when fetching data
            this.placeholderService.show(CommonConstant.DISCOVER_POST_LIST_HOLDER);
            // make the search
            this.fetchDiscoverInfluencerSubcription = this.discoverService.searchPosts(filterSearch)
                .subscribe(function (res) {
                _this.showWarningSearchMessage = true;
                _this.searchRunning = false;
                // update current offset
                _this.currentOffset = filterSearch.offset + filterSearch.limit;
                // update search result for current discover list, filter duplicates
                // TODO: Remove this hacky solution
                var nextResult = res.posts.filter(function (i) { return !_this.discoverPosts.find(function (d) { return d.urlHash === i.urlHash; }); });
                _this.discoverPosts = _this.discoverPosts.concat(nextResult);
                // update Tab state
                _this.updateTabState();
                // filter seleted item already in the previewed list
                _this.filterPreviewedItemAsSelected(DiscoverTab.POST);
                _this.placeholderService.hide(CommonConstant.DISCOVER_POST_LIST_HOLDER);
                // Set result count and pagination values
                _this.totalDiscoverPost = res.totalPosts;
                _this.updateSearchAfter(res.lastSortValues);
                _this.cacheService.set(CommonConstant.HAVE_TRIGGERED_DISCOVER_POST, true);
                _this.preloadDataForDiscoverPost(filterSearch);
            }, function (err) {
                _this.placeholderService.hide(CommonConstant.DISCOVER_POST_LIST_HOLDER);
            });
        }
    };
    DiscoverComponent.prototype.searchDiscoverInfluencer = function (filterSearch, preloadData) {
        var _this = this;
        // should not show placeholder when preloading data
        if (preloadData) {
            this.isFetchingNextInfluencers = true;
            this.preloadDiscoverInfluencerSubcription = this.discoverService.searchInfluencers(filterSearch)
                .subscribe(function (res) {
                _this.isFetchingNextInfluencers = false;
                // update total result and pagination data
                if (res.totalInfluencers && res.lastSortValues) {
                    _this.totalDiscoverInfluencer = res.totalInfluencers;
                    _this.updateSearchAfter(res.lastSortValues);
                }
                if (_this.isWaitingNextInfluencers) {
                    // update search result for current discover list, filter duplicates
                    // TODO: Remove this hacky solution
                    var nextResult = res.influencers.filter(function (i) { return !_this.discoverInfluencers.find(function (d) { return d.id === i.id; }); });
                    _this.discoverInfluencers = _this.discoverInfluencers.concat(nextResult);
                    _this.isWaitingNextInfluencers = false;
                    _this.placeholderService.hide(CommonConstant.DISCOVER_INFLUENCER_LIST_HOLDER);
                    // Set result count and pagination values
                    if (res.totalInfluencers && res.lastSortValues) {
                        _this.preloadDataForDiscoverInfluencer(filterSearch);
                    }
                }
                else {
                    _this.storedDiscoverInfluencers = res.influencers;
                }
            }, function (err) {
                _this.placeholderService.hide(CommonConstant.DISCOVER_INFLUENCER_LIST_HOLDER);
            });
        }
        else {
            // mark search as running
            this.searchRunning = true;
            this.showWarningSearchMessage = false;
            this.updateSearchAfter([]);
            // show placeholder when fetching data
            this.placeholderService.show(CommonConstant.DISCOVER_INFLUENCER_LIST_HOLDER);
            // make the search
            this.fetchDiscoverInfluencerSubcription = this.discoverService.searchInfluencers(filterSearch)
                .subscribe(function (res) {
                _this.showWarningSearchMessage = true;
                _this.searchRunning = false;
                // update search result for current discover list, filter duplicates
                // TODO: Remove this hacky solution
                var nextResult = res.influencers.filter(function (i) { return !_this.discoverInfluencers.find(function (d) { return d.id === i.id; }); });
                _this.discoverInfluencers = _this.discoverInfluencers.concat(nextResult);
                // update Tab state
                _this.updateTabState();
                // filter seleted item already in the previewed list
                _this.filterPreviewedItemAsSelected(DiscoverTab.INFLUENCER);
                _this.placeholderService.hide(CommonConstant.DISCOVER_INFLUENCER_LIST_HOLDER);
                // Set result count and pagination values
                if (res.totalInfluencers && res.lastSortValues) {
                    _this.currentOffset = filterSearch.offset + filterSearch.limit;
                    _this.totalDiscoverInfluencer = res.totalInfluencers;
                    _this.updateSearchAfter(res.lastSortValues);
                    _this.preloadDataForDiscoverInfluencer(filterSearch);
                }
                _this.cacheService.set(CommonConstant.HAVE_TRIGGERED_DISCOVER_INFLUENCER, true);
            }, function (err) {
                _this.placeholderService.hide(CommonConstant.DISCOVER_INFLUENCER_LIST_HOLDER);
            });
        }
    };
    /**
     * Update pagination values
    */
    DiscoverComponent.prototype.updateSearchAfter = function (lastSortValues) {
        this.lastSortValues = lastSortValues;
        this.currentFilterSearch.searchAfter = [];
        if (this.lastSortValues != null && this.lastSortValues.length > 0) {
            this.currentFilterSearch.searchAfter = this.lastSortValues;
        }
    };
    /**
     * Filter preview item was selected
     * Set that item as selected to avoid select the same influencer in the next search
     */
    DiscoverComponent.prototype.filterPreviewedItemAsSelected = function (tabKey) {
        var _this = this;
        if (this.selectedPreviewInfluencers.length > 0 && tabKey === DiscoverTab.INFLUENCER) {
            this.selectedPreviewInfluencers.map(function (item) { return Object.assign({}, item, {
                selected: _this.filterSelectedDiscoverInfluencer(item.influencer_id)
            }); });
        }
        if (this.selectedPreviewPosts.length > 0 && tabKey === DiscoverTab.POST) {
            this.selectedPreviewPosts.map(function (item) { return Object.assign({}, item, {
                selected: _this.filterSelectedDiscoverPost(item.influencer_id)
            }); });
        }
    };
    DiscoverComponent.prototype.filterSelectedDiscoverInfluencer = function (influencerId) {
        var existedItems = this.discoverInfluencers.filter(function (influencer) { return influencer.influencer_id === influencerId; });
        return existedItems.length > 0;
    };
    DiscoverComponent.prototype.filterSelectedDiscoverPost = function (influencerId) {
        var existedItems = this.discoverPosts.filter(function (influencer) { return influencer.influencer_id === influencerId; });
        return existedItems.length > 0;
    };
    DiscoverComponent.prototype.cancelPendingSearchRequest = function () {
        if (this.fetchDiscoverInfluencerSubcription) {
            //  hide loader
            this.placeholderService.hideImmediately(CommonConstant.DISCOVER_INFLUENCER_LIST_HOLDER);
            this.placeholderService.hideImmediately(CommonConstant.DISCOVER_POST_LIST_HOLDER);
            this.fetchDiscoverInfluencerSubcription.unsubscribe();
        }
        if (this.preloadDiscoverInfluencerSubcription) {
            this.preloadDiscoverInfluencerSubcription.unsubscribe();
        }
    };
    DiscoverComponent.prototype.computeNextResultLimitAndOffset = function (filterSearch) {
        var currentOffset = filterSearch.offset || 0;
        var currentLimit = filterSearch.limit || 0;
        var nextOffset = currentOffset + currentLimit;
        var maxResultPerSearch = this.userService.maxResultPerSearch;
        if (!maxResultPerSearch) {
            filterSearch.limit = discoverFilterSearchConst.limit;
            filterSearch.offset = nextOffset;
        }
        else {
            var totalRemainingResult = maxResultPerSearch - nextOffset;
            var limit = totalRemainingResult > discoverFilterSearchConst.limit ?
                discoverFilterSearchConst.limit : totalRemainingResult;
            filterSearch.limit = limit;
            filterSearch.offset = nextOffset;
        }
    };
    Object.defineProperty(DiscoverComponent.prototype, "shouldShowSubscriptionWarning", {
        get: function () {
            if (!this.isRenderedPostList && this.tabKey === DiscoverTab.POST) {
                return false;
            }
            var maxResultPerSearch = this.userService.maxResultPerSearch;
            var totalResult = document.getElementsByClassName('grid-item').length;
            var reachedLimitation = false;
            if (this.currentOffset) {
                reachedLimitation = (this.currentOffset === maxResultPerSearch);
            }
            return maxResultPerSearch && !Number.isNaN(totalResult) && maxResultPerSearch <= totalResult
                && reachedLimitation && !this.searchRunning && !this.missingRequiredFilters;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DiscoverComponent.prototype, "maxResultPerSearch", {
        get: function () {
            return this.userService.maxResultPerSearch;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DiscoverComponent.prototype, "totalDiscoveryResult", {
        get: function () {
            if (this.tabKey === DiscoverTab.POST) {
                return this.totalDiscoverPost;
            }
            else {
                return this.totalDiscoverInfluencer;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DiscoverComponent.prototype, "totalDisplayPost", {
        get: function () {
            var maxDisplayResult = this.userService.maxResultPerSearch;
            if (maxDisplayResult && maxDisplayResult < this.totalDiscoverPost) {
                return maxDisplayResult;
            }
            else {
                return this.totalDiscoverPost;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DiscoverComponent.prototype, "totalDisplayInfluencer", {
        get: function () {
            var maxDisplayResult = this.userService.maxResultPerSearch;
            if (maxDisplayResult && maxDisplayResult < this.totalDiscoverInfluencer) {
                return maxDisplayResult;
            }
            else {
                return this.totalDiscoverInfluencer;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DiscoverComponent.prototype, "storyIncompleteMessage", {
        get: function () {
            return this._storyIcompleteMessage;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DiscoverComponent.prototype, "target", {
        get: function () {
            return this.currentFilterSearch && this.currentFilterSearch.audienceFilters.length > 0 ? 'discover' : null;
        },
        enumerable: true,
        configurable: true
    });
    DiscoverComponent.prototype.trackByFn = function (index, item) {
        return item.id;
    };
    return DiscoverComponent;
}(AbstractAchooComponent));
export { DiscoverComponent };



// WEBPACK FOOTER //
// ./src/app/main/discover/discover.component.ts.pre-build-optimizer.js